<template>
  <div>
    <el-button @click="addP">增加属性</el-button>
    <div style="font-size: 0.18rem">{{user.name}}-{{user.age}}</div>
  </div>

</template>

<script>
// 引入 ECharts 主模块
var echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/chart/pie");
require("echarts/lib/component/markLine");
require("echarts/lib/component/geo");
require("echarts/lib/chart/scatter");
require("echarts/lib/chart/map");
export default {
  data() {
    return {
      user:{"name":"张三"}
    };
  },
  created() {

  },
  mounted() {
    this.drawCharts();
  },
  methods: {
    addP(){
      this.user.age="13";
    },
    drawCharts() {
      // 基于准备好的dom，初始化echarts实例
      var chinaMap = echarts.init(document.getElementById("china-map"));
      window.onresize = chinaMap.resize; // 窗口或框架被调整大小时执行chinaMap.resize
      chinaMap.setOption({
        tooltip: {
          backgroundColor: '#0000ff', // 背景颜色
          borderColor: '#ff0000', // 边框颜色
          textStyle: {
            color: '#ffffff' // 字体颜色
          },
          trigger: 'item',
          formatter: (params) => {
            console.log(params.data)
            let data=params.data;
            if (params.value) {
              return `${data.name}: ${data.value}<br />第二行示例内容,学校:${data.school}`;
            } else {
              return `${params.name}: 暂无数据`;
            }
          }
        },
        geo: {
          map: "china",
          roam: true,
          label: {
            normal: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            emphasis: {
              show: true,
              textStyle: {
                color: "red", // 自定义悬停时的文字颜色
              },
            },
          },
          itemStyle: {
            normal: {
              borderColor: "#293171", // 分界线颜色
              borderWidth: "2",
              areaColor: "#0A0F33", // 区域颜色
            },
            emphasis: {
              areaColor: "yellow", // 自定义悬停时的区域颜色
              borderColor: "yellow", // 自定义悬停时的边界颜色
              borderWidth: 2,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
        series: [
          {
            type: "scatter",
            coordinateSystem: "geo",
          },
          {
            name: "项目",
            type: "map",
            geoIndex: 0,
            data: [
              {
                name: "北京",
                value: 599,
              },
              {
                name: "上海",
                value: 142,
              },
              {
                name: "黑龙江",
                value: 44,
                school:1
              },
              {
                name: "深圳",
                value: 92,
              },
              {
                name: "湖北",
                value: 810,
              },
              {
                name: "四川",
                value: 888,
              },
              {
                name: "新疆",
                value: 666,
              },
              {
                name: "河南",
                value: 888,
              },
            ],
          },
        ],
      });

    },
  },
};
</script>

<style lang="scss" scoped>
.managingPatientSize {
  height: 100%;
  background-color: #ffffff;
  color: #fff;

  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
      position: relative;
      #china-map {
        height: 100%;
      }
    }
  }
}
.con{
  .left{
    .item{
      width: 100%;
      padding-bottom: 0.4rem;
      border-bottom:0.01rem solid #999999;
      .line1{
        display: flex;
        align-items: flex-end;
        .num{
          font-family: DIN Condensed, DIN Condensed;
          font-weight: bold;
          font-size: 0.54rem;
          color: #000000;
        }
        .text{
          font-weight: 500;
          font-size: 0.26rem;
          color: #333333;
          margin-bottom: 0.08rem;
          margin-left: 0.18rem;
        }
      }
      .line2{
        margin-top: 0.2rem;
        font-weight: 400;
        font-size:0.2rem;
        color: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/test.vue